import Loading from '@/common/components/Loading';
import { useRequestsContext } from '@/common/hooks/requestHook';
import React from 'react';
import { PageWrapper } from '@/common/styles/Wrappers';
import { findConsultantRefundsByMarketsAndStatus } from '@/API/repositories/consultantRefunds';
import { useRefunds } from './hooks/useRefunds';
import RefundsSearchBar from './components/refundSearchBar/RefundSearchBar';
import RefundTable from './components/refundTable/RefundTable';
import PopUp from '@/common/components/PopUp';
import RefundDetails from './components/refundDetails/refundDetails';
import Confirmation from './components/confirmation/confirmation';

const Refunds = () => {
	const hook = useRefunds();

	const { hasUnfilledRequest } = useRequestsContext();

	return (
		<PageWrapper>
			{hasUnfilledRequest(findConsultantRefundsByMarketsAndStatus) && <Loading />}
			<RefundsSearchBar
				hook={hook}
			/>
			{!!hook.refunds.length && <RefundTable hook={hook}/>}
			{hook.selectedRefund && 
				<PopUp setShow={hook.setSelectedRefund}>
					<RefundDetails hook={hook}/>
				</PopUp>
			}
			{hook.confirmationPopup && 
				<PopUp setShow={hook.setConfirmationPopup}>
					<Confirmation hook={hook}/>
				</PopUp>
			}
		</PageWrapper>
	);
};

export default Refunds;
